import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 120 } };
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes: [
    { path: "/", redirect: "/index.html" },
    {
      path: "/index.html",
      name: "home",
      component: () => import("./views/Landing.vue")
    },
    {
      path: "/chapter/:chapterIndex/index.html",
      name: "chapter",
      component: () => import("./views/Chapter.vue")
    },
    {
      path: "/eni_numeri/index.html",
      name: "eni_numeri",
      component: () => import("./views/EniNumeri.vue")
    },
    {
      path: "/video/:videoId/index.html",
      name: "video",
      component: () => import("./views/VideoView.vue")
    },
    {
      path: "/documents/index.html",
      name: "documents",
      component: () => import("./views/Documents.vue")
    }
  ]
});
